import React, { ReactElement, ReactNode } from 'react'
import styles from './styles/tabNavigation.module.scss'
import { Tabs, Tab } from 'react-bootstrap'
import classNames from 'classnames'

interface TabContentProps {
  activeTabKey: string
  tabKey: string
  children: ReactNode
}

export const TabContent = ({ activeTabKey, tabKey, children }: TabContentProps) => {
  return <>{activeTabKey === tabKey && children}</>
}

export interface TabObj {
  id: string
  key: string
  title: ReactNode
  className?: string
  hasNotification?: boolean
}

type ColorScheme = 'primary' | 'secondary'
type TabStyle = 'squared' | 'chip'

interface TabNavigationProps {
  id: string
  tabs: TabObj[]
  onTabSelect: (activeTabKey: string | null) => void
  activeTabKey: string
  colorScheme?: ColorScheme
  tabStyle?: TabStyle
  containerClass?: string
  withOverheadTabs?: boolean
  withArrows?: boolean
}

const TabNavigation = ({
  id,
  tabs,
  activeTabKey,
  onTabSelect,
  colorScheme = 'primary',
  tabStyle = 'squared',
  containerClass = '',
  withOverheadTabs = false,
  withArrows = false,
}: TabNavigationProps) => {
  return (
    <div
      className={classNames(
        styles.tabsContainer,
        styles[colorScheme],
        styles[tabStyle],
        containerClass,
        {
          [styles.overheadTabs]: withOverheadTabs,
          [styles.withArrows]: withArrows,
        }
      )}
    >
      <Tabs onSelect={onTabSelect} activeKey={activeTabKey} id={id}>
        {tabs.map(({ id, key, title, className, hasNotification }) => (
          <Tab
            key={id}
            eventKey={key}
            title={title}
            tabClassName={classNames(className, {
              [styles.withNotificationBadge]: hasNotification,
            })}
          />
        ))}
      </Tabs>
    </div>
  )
}

interface TabNavigationModuleProps {
  children: ReactElement<TabContentProps>[]
  navId: string
  navColorScheme?: ColorScheme
  navClass?: string
  containerClass?: string
  tabs: TabObj[]
  tabStyle?: TabStyle
  onTabSelect: (activeTabKey: string | null) => void
  activeTabKey: string
  withOverheadTabs?: boolean
  withArrows?: boolean
}

export const TabNavigationModule = ({
  children,
  navId,
  navColorScheme,
  navClass = '',
  containerClass = '',
  tabs,
  activeTabKey,
  onTabSelect,
  withOverheadTabs = false,
  withArrows = false,
  tabStyle = 'squared',
}: TabNavigationModuleProps) => {
  return (
    <section className={classNames(styles.outerContainer, containerClass)}>
      <TabNavigation
        id={navId}
        tabs={tabs}
        activeTabKey={activeTabKey}
        onTabSelect={onTabSelect}
        colorScheme={navColorScheme}
        containerClass={navClass}
        withOverheadTabs={withOverheadTabs}
        withArrows={withArrows}
        tabStyle={tabStyle}
      />
      {children}
    </section>
  )
}

export default TabNavigation
